export enum MyDigitsActionTypes {
  GET_LINE_DETAILS = "GET_LINE_DETAILS",
  LINE_DETAILS_STATUS = "LINE_DETAILS_STATUS",
  UPDATE_USER_INFO = "UPDATE_USER_INFO",
  UPDATE_LINE_DETAILS = "UPDATE_LINE_DETAILS",
  UPDATE_GIVEN_NAME = "UPDATE_GIVEN_NAME",
  FILTER_LINE_DETAILS = "FILTER_LINE_DETAILS",
  SET_SELECTED_LINE = "SET_SELECTED_LINE",
  SET_ASSIGNED_LINE = "SET_ASSIGNED_LINE",
  RESET_ASSIGNEE_MSISDN = "RESET_ASSIGNEE_MSISDN",
  GET_LINE_PAIR = "GET_LINE_PAIR",
  UPDATE_PAIR_LINE = "UPDATE_PAIR_LINE",
  UNPAIR_LINE = "UNPAIR_LINE",
  PAIR_LINE = "PAIR_LINE",
  SET_UN_ASSIGNED_LINE = "SET_UN_ASSIGNED_LINE",
  RESET_LINE_DETAILS = "RESET_LINE_DETAILS",
  USER_LOGOUT = "USER_LOGOUT",
  CHNAGE_TAB = "CHANGE_TAB",
}

export interface Digits {
  id: number;
  lines: {
    header: string;
    data: LinesData[];
  };
}

export interface LinesData {
  id: number;
  lineName: string;
  phoneNumber: string;
}
